import React from "react";
import { CiLocationOn } from "react-icons/ci";
import { MdOutlineMail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { TiSocialFacebook } from "react-icons/ti";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import styles from "./home.module.css";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className=" hidden lg:flex bg-[#013220] p-14 justify-between">
        <div className="text-white">
          <h1 className="text-2xl text-[#518270] font-medium mb-6">
            Quick Links
          </h1>
          <ul className=" text-base mt-3 flex gap-4 flex-col">
            <Link to={`/about`}>About</Link>
            <Link to={`/warehouse`}>Gefmart Warehouse</Link>
            <Link to="/categories">Categories</Link>
            <Link to="/brands">Top Brands</Link>
            <Link to="/marketplace">Marketplace</Link>
            <Link to="/marketplace/add">Sell on Gefmart</Link>
            <li
              onClick={() => {
                navigate("/login");
                Cookies.remove("gefmartUserToken");
              }}
              style={{ cursor: "pointer" }}
            >
              Logout
            </li>
          </ul>
        </div>
        <div className=" max-w-sm">
          <div className="text-white">
            <h1 className="text-2xl text-[#518270] font-medium mb-6">
              Contact
            </h1>
            <ul className=" text-base mt-3 flex gap-4 flex-col justify-center">
              <li className="flex justify-center gap-3">
                <span className="mt-1">
                  <CiLocationOn />
                </span>{" "}
                <p>
                  Geften Electrical Solutions LLP 39/2475-B1, Suite 716, LR
                  Towers, SJRRA 104, South Janatha Road, Palarivattom PO, Kochi
                  Ernamkulam (Dist) Kerala-682025
                </p>
              </li>
              <li className="flex items-center gap-3">
                <span>
                  <MdOutlineMail />
                </span>
                <p>support@geften.com </p>{" "}
              </li>
              <div className="flex flex-col gap-1 bg-[#1F503E] w-72 justify-center p-5 rounded-lg">
                <a
                  href={`https://api.whatsapp.com/send?phone=+918921951010&text=Hello%20Gefmart`}
                  target="_blank"
                  rel="noreferrer"
                  className="flex gap-1 items-center"
                >
                  <FaWhatsapp className="text-3xl" /> <p>+91 892 195 1010</p>
                </a>
                <p className={styles.contactTime}>
                  9:00 am to 7:00 pm (Mon-Sat)
                </p>
              </div>
            </ul>
          </div>
        </div>
        <div>
          {" "}
          <div className="text-white">
            <h1 className="text-2xl text-[#518270] font-medium mb-6">
              Resources
            </h1>
            <ul className=" text-base mt-3 flex gap-4 flex-col">
              {/* <Link to={"#"}>Terms and Conditions</Link> */}
              {/* <Link to={`#`}>Privacy Policy</Link> */}
              {/* <Link to={`#`}>Refund Policy</Link> */}
              <Link to={`blog`}>Blogs</Link>
              {/* <li>Visit our Website</li> */}
            </ul>
          </div>
        </div>
        <div>
          {" "}
          <div className="text-white">
            <h1 className="text-2xl text-[#518270] font-medium mb-6">
              Download our App
            </h1>
            <ul className="text-base mt-3 flex gap-4 flex-col">
              <li>
                <img
                  className="cursor-pointer w-44 rounded-md"
                  src="/Screenshot 2024-03-06 210505.png"
                  alt="Download gefmart from play store"
                  onClick={() => {
                    window.open(
                      "https://apps.apple.com/ph/app/gefmart/id6502963364"
                    );
                  }}
                />
              </li>
              <li>
                <img
                  className="cursor-pointer w-44 rounded-md"
                  src="/Screenshot 2024-03-06 210534.png"
                  alt="Download gefmart from app store"
                  onClick={() => {
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.gefmart.app"
                    );
                  }}
                />
              </li>
              <h1 className="text-2xl text-[#518270] font-medium">
                Follow us on
              </h1>
              <li className="cursor-pointer flex gap-3">
                <span
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/profile.php?id=61551943805650"
                    )
                  }
                >
                  <TiSocialFacebook className=" bg-blue-600 text-2xl rounded-full" />
                </span>
                <span>
                  <img
                    className="cursor-pointer w-6"
                    src="/toppng.com-ew-instagram-logo-transparent-related-keywords-logo-instagram-vector-2017-515x515.png"
                    alt="gefmart instagram"
                    onClick={() => {
                      window.open("https://www.instagram.com/gefmartapp/");
                    }}
                  />
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="bg-[#1F503E] w-full text-center hidden lg:block">
        <p className=" text-[#628478] py-2">
          Copyright © 2025 Geften. Developed by{" "}
          <a
            href="https://codescap.com"
            target="_blank"
            style={{ color: "white" }}
          >
            Codescap
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
